import React, { useEffect, useState, useCallback } from "react";
import "../../styles/Gallery.css";
import api from "../../utils/api";

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ Fetch Gallery
  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const { data } = await api.get("/gallery");

        // VERY IMPORTANT
        setImages(data.data);
      } catch (error) {
        console.error("Gallery fetch failed:", error);
      } finally {
        setLoading(false);
        setTimeout(() => setIsVisible(true), 100);
      }
    };

    fetchGallery();
  }, []);

  // ✅ Lightbox Controls
  const openLightbox = (index) => {
    setLightboxIndex(index);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    setLightboxIndex(null);
    document.body.style.overflow = "auto";
  };

  const goNext = useCallback(() => {
    setLightboxIndex((prev) => (prev + 1) % images.length);
  }, [images.length]);

  const goPrev = useCallback(() => {
    setLightboxIndex((prev) => (prev - 1 + images.length) % images.length);
  }, [images.length]);

  // ✅ Keyboard Navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (lightboxIndex === null) return;

      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") goNext();
      if (e.key === "ArrowLeft") goPrev();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [lightboxIndex, goNext, goPrev]);

  // ✅ Loading UI (Temporary — skeleton later)
  if (loading) {
    return (
      <section className="section-container">
        <p style={{ textAlign: "center", padding: "80px 0" }}>
          Loading gallery...
        </p>
      </section>
    );
  }

  return (
    <section className="section-container">
      <section className={`gallery-section ${isVisible ? "fade-in" : ""}`}>
        <h4 className="college-name-gallery">
          SHRI MULIKADEVI MAHAVIDYALAYA, NIGHOJ
        </h4>

        <h2 className="heading">Campus Glimpses</h2>

        <p className="subheading">
          A visual journey through the vibrant student life and memorable events.
        </p>

        {/* ✅ Gallery Grid */}
        <div className="gallery-grid">
          {images.map((img, index) => (
            <div className="gallery-card" key={img._id}>
              <img
                src={img.imageUrl}
                alt={img.title}
                loading="lazy"   // ⭐ Performance boost
                onClick={() => openLightbox(index)}
              />
              <h3>{img.title}</h3>
            </div>
          ))}
        </div>

        {/* ✅ Lightbox */}
        {lightboxIndex !== null && (
          <div className="lightbox" onClick={closeLightbox}>
            <span className="close-btn">&times;</span>

            <img
              src={images[lightboxIndex].imageUrl}
              alt={images[lightboxIndex].title}
              className="lightbox-img"
              onClick={(e) => e.stopPropagation()}
            />

            <h4 className="lightbox-caption">
              {images[lightboxIndex].title}
            </h4>

            <button
              className="nav-btn prev-btn"
              onClick={(e) => {
                e.stopPropagation();
                goPrev();
              }}
            >
              &#10094;
            </button>

            <button
              className="nav-btn next-btn"
              onClick={(e) => {
                e.stopPropagation();
                goNext();
              }}
            >
              &#10095;
            </button>
          </div>
        )}
      </section>
    </section>
  );
};

export default Gallery;
